export function formatDate(value?: string, withTime = true) {
  if (!value) return "—";

  const brMatch = value.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/,
  );
  const date = brMatch
    ? new Date(
        Number(brMatch[3]),
        Number(brMatch[2]) - 1,
        Number(brMatch[1]),
        Number(brMatch[4] ?? 0),
        Number(brMatch[5] ?? 0),
        Number(brMatch[6] ?? 0),
      )
    : new Date(value);

  if (Number.isNaN(date.getTime())) return value;

  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(date);
}

export function relativeDate(value?: string) {
  if (!value) return "Sem atualização";
  const brMatch = value.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2}))?/,
  );
  const date = brMatch
    ? new Date(
        Number(brMatch[3]),
        Number(brMatch[2]) - 1,
        Number(brMatch[1]),
        Number(brMatch[4] ?? 0),
        Number(brMatch[5] ?? 0),
      )
    : new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const minutes = Math.round((date.getTime() - Date.now()) / 60_000);
  const formatter = new Intl.RelativeTimeFormat("pt-BR", { numeric: "auto" });
  if (Math.abs(minutes) < 60) return formatter.format(minutes, "minute");
  const hours = Math.round(minutes / 60);
  if (Math.abs(hours) < 24) return formatter.format(hours, "hour");
  return formatter.format(Math.round(hours / 24), "day");
}

function toInputDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function defaultTicketPeriod() {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - 365);
  return {
    startDate: toInputDate(start),
    endDate: toInputDate(end),
  };
}
